import React , { useEffect, useState }  from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CreateCountry = (props) => {
    const [Country,setCountry] = useState('');
    const [CountryISO,setCountryISO] = useState('');
    const [response, fetchData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();

    const validationSchema = Yup.object({
        Country:Yup.string().required('Required!'),
        CountryISO:Yup.string().max(5).required('Required!'),
    });

    const onSubmit = values => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Country');
        bodyFormData.append("PKID", props.PKID);
        bodyFormData.append("Value1", values.Country);
        bodyFormData.append("Value2", values.CountryISO);
        fetchData("Primary/Save", bodyFormData);
    };

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Country');
        bodyFormData.append("PKID", props.PKID);
        fetchGetData("Primary/GetByID", bodyFormData);
    }

    useEffect(() => {
        if(response.Response === true){
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if(response.Response === false){
            alert('Save Failed.')
        }
    },[response])

    useEffect(() => {
        if(responseGetData.length > 0){
            setCountry(responseGetData[0].Country);
            setCountryISO(responseGetData[0].CountryISO);
        }
    },[responseGetData])

    useEffect(() => {
        if(props.PKID !== ''){
            getByIDData();
        }
    },[])

    return(
        <div>
            <Formik initialValues={{Country:Country,CountryISO:CountryISO}} 
            validationSchema = {validationSchema} onSubmit = {onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container>
                            <Grid item xs={12}>
                                <BiztranControlsFormik 
                                    control='input' 
                                    type='text' 
                                    label='Country Name'
                                    name='Country' 
                                    onChange={(e) => setCountry(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik 
                                    control='input' 
                                    type='text' 
                                    label='Country ISO Name'
                                    name='CountryISO' 
                                    onChange={(e) => setCountryISO(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{width:'100%'}}>
                                    <div style={{display:'flex',justifyContent:'center',alignContent:"center"}}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon/>}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => {props.setOpen(false);}}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default CreateCountry;
